var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 662,
    viewBox: "0 0 1440 662",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 613.75C0 630.551 0 638.952 3.2698 645.369C6.14601 651.014 10.7354 655.604 16.3803 658.48C22.7976 661.75 31.1984 661.75 48 661.75H1354.06C1382.14 661.75 1396.18 661.75 1404.13 655.869C1411.06 650.742 1415.45 642.881 1416.18 634.291C1417.02 624.437 1409.66 612.484 1394.93 588.577L1114.02 132.501C1109.46 125.097 1107.18 121.395 1104.13 118.583C1101.42 116.092 1098.27 114.121 1094.85 112.768C1090.99 111.24 1086.66 110.8 1078.01 109.92L52.8583 5.62384C34.5456 3.76074 25.3892 2.82922 18.3101 5.82446C12.092 8.45538 6.94315 13.1069 3.69637 19.0269C0 25.7664 0 34.9701 0 53.3773V613.75Z",
    fill: "#FEC901"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_98_15",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 1417,
    height: 659
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 616.749C0 630.727 0 637.716 2.28361 643.23C5.32843 650.58 11.1687 656.421 18.5195 659.465C24.0326 661.749 31.0218 661.749 45 661.749H1359.43C1382.77 661.749 1394.44 661.749 1401.47 657.622C1410.85 652.12 1416.51 641.977 1416.28 631.109C1416.11 622.958 1409.99 613.022 1397.75 593.15L1113.25 131.239C1109.45 125.073 1107.55 121.99 1105.12 119.537C1101.87 116.266 1097.92 113.787 1093.56 112.291C1090.29 111.169 1086.69 110.802 1079.49 110.069L49.5546 5.28717C34.3219 3.73743 26.7055 2.96259 20.6582 4.94415C12.5952 7.5863 6.02813 13.5192 2.58348 21.2734C0 27.089 0 34.7447 0 50.0561V616.749Z",
    fill: "#0081FE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_98_15)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M806.704 593.955C784.489 580.06 764.887 563.638 749.205 544.69C770.114 538.374 789.716 529.532 806.704 519.426C829.573 505.531 849.175 488.478 864.857 468.898C875.311 475.214 887.072 480.267 900.794 484.056C918.436 488.478 939.344 491.004 964.174 491.004C1098.12 491.004 1120.99 418.37 1120.99 310.998L1120.99 47.6197L807.358 47.6197L807.358 235.837C807.358 323.63 789.716 388.053 711.961 408.896C706.081 410.791 698.893 412.054 692.359 413.317C689.746 397.527 689.092 381.105 689.092 364.684L689.092 -94.4907L1240.56 -94.4907L1240.56 364.684C1240.56 508.057 1152.35 633.746 964.827 633.746C900.14 633.746 847.868 618.588 806.704 593.955Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M648.582 558.197C685.826 558.197 719.149 553.144 749.206 544.302C770.114 537.986 789.716 529.143 806.705 519.037C829.574 505.142 849.176 488.089 864.857 468.509C879.886 450.825 891.647 430.613 900.794 409.139C916.476 372.506 924.317 332.083 924.317 289.766L924.317 47.231L807.358 47.231L807.358 235.448C807.358 323.241 789.716 387.664 711.962 408.507C706.081 410.402 698.894 411.665 692.36 412.928C679.292 414.823 664.917 416.086 648.582 416.086C514.635 416.086 491.766 343.452 491.766 236.08L491.766 47.231L688.439 47.231L688.439 -94.8794L372.847 -94.8794L372.847 289.766C372.847 432.508 461.056 558.197 648.582 558.197Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.8257be0e0b2161e8a79d335357a4abc3.svg";
export { ForwardRef as ReactComponent };